import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
type Variant = 'solid' | 'ghost' | 'inverted';
type Size = 'sm' | 'md';
const base = 'inline-flex items-center justify-center font-mono text-[12px] uppercase tracking-[0.08em] border transition-colors duration-200 ease-editorial no-underline';
const variants: Record<Variant, string> = {
  solid: 'border-ink bg-ink text-bone hover:bg-transparent hover:text-ink',
  ghost: 'border-ink bg-transparent text-ink hover:bg-ink hover:text-bone',
  inverted: 'border-bone bg-bone text-ink hover:bg-transparent hover:text-bone'
};
const sizes: Record<Size, string> = {
  sm: 'px-4 py-2',
  md: 'px-[18px] py-[10px]'
};
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}
export function Button({
  className,
  variant = 'solid',
  size = 'md',
  ...props
}: ButtonProps) {
  return <button className={cn(base, variants[variant], sizes[size], className)} {...props} data-id="element-158" data-mp="jpsg7o4r0jz3" />;
}
interface ButtonLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: Variant;
  size?: Size;
}
export function ButtonLink({
  className,
  variant = 'solid',
  size = 'md',
  ...props
}: ButtonLinkProps) {
  return <a className={cn(base, variants[variant], sizes[size], className)} {...props} data-id="element-159" data-mp="oq6pf9i35zyp" />;
}